<template>
    <footer
        :class="[
            'md-footer upgrade',
            { inner: inner, fixed: fixed },
            fixedZindexCls
        ]"
        :style="colorMapStyle"
    >
        <div class="mls-wrap">
            <MlsDisclaimer
                v-if="!wordPressSSR"
                theme="upgrade"
                @update="mlsUpdated"
                class="f-col"
            />
        </div>
        <div
            class="footer-container"
            :style="{ backgroundColor: bgColor, color: fontColor }"
        >
            <div class="mg-container">
                <div class="main-content">
                    <div class="left-content">
                        <div v-if="logos.length > 0" class="site-logo">
                            <template v-for="(logo, index) in validLogos">
                                <a
                                    v-if="logo.logo.href"
                                    :key="index"
                                    :href="logo.logo.href"
                                    aria-label="site logo"
                                    rel="noopener noreferrer"
                                >
                                    <site-img
                                        class="logo-item"
                                        :src="logo.logo"
                                        alt="site logo"
                                        :style="{ height: size / 100 + 'em' }"
                                        :ssrInitSize="30"
                                        dir="height"
                                    />
                                </a>
                                <site-img
                                    v-else
                                    class="logo-item"
                                    :key="'key-' + index"
                                    :src="logo.logo"
                                    alt="site logo"
                                    :style="{ height: size / 100 + 'em' }"
                                    :ssrInitSize="30"
                                    dir="height"
                                />
                            </template>
                        </div>
                        <div class="detail-info">
                            <template v-if="!!companyInfo">
                                <p v-if="!!companyInfo.name" class="co-name">
                                    <span
                                        :style="useBroNameStyle"
                                        v-html="companyInfo.name"
                                    >
                                    </span>
                                </p>
                            </template>
                            <p
                                v-if="
                                    !!footerAgentInfo.firstName ||
                                        !!footerAgentInfo.lastName
                                "
                                :style="useAgentNameStyle"
                                class="detail-name"
                            >
                                {{ footerAgentInfo.firstName || '' }}
                                {{ footerAgentInfo.lastName || '' }}
                            </p>
                            <p
                                :style="useAgentLicenseStyle"
                                v-if="!!footerAgentInfo.license"
                                class="detail-license"
                            >
                                {{ global.licenseName }}
                                {{ footerAgentInfo.license }}
                            </p>
                            <p class="detail-phone-email">
                                <span
                                    v-if="!!footerAgentInfo.phone"
                                    :style="useAgentPhoneStyle"
                                    class="detail-phone"
                                >
                                    <a
                                        :href="'tel:' + footerAgentInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(
                                                footerAgentInfo.phone
                                            )
                                        }}
                                    </a>
                                </span>
                                <span
                                    v-if="!!footerAgentInfo.email"
                                    class="detail-email"
                                    :style="useAgentEmailStyle"
                                >
                                    <a
                                        :href="
                                            'mailto:' + footerAgentInfo.email
                                        "
                                        rel="noopener noreferrer"
                                    >{{ footerAgentInfo.email }}</a>
                                </span>
                            </p>
                        </div>
                        <div
                            class="detail subdomain-detail"
                            v-if="subOwnerInfo"
                        >
                            <p class="detail-info">
                                <span
                                    v-if="
                                        !!subOwnerInfo.firstName ||
                                            !!subOwnerInfo.lastName
                                    "
                                    class="detail-name"
                                    :style="useAgentNameStyle"
                                >
                                    {{ subOwnerInfo.firstName || '' }}
                                    {{ subOwnerInfo.lastName || '' }}
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="!!subOwnerInfo.phone"
                                    class="detail-phone"
                                    :style="useAgentPhoneStyle"
                                >
                                    <a
                                        :href="'tel:' + subOwnerInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(subOwnerInfo.phone)
                                        }}
                                    </a>
                                </span>
                                <span
                                    v-if="!!subOwnerInfo.email"
                                    class="detail-email"
                                    :style="useAgentEmailStyle"
                                >
                                    <a
                                        :href="'mailto:' + subOwnerInfo.email"
                                        rel="noopener noreferrer"
                                    >
                                        {{ subOwnerInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </div>
                        <div
                            v-if="getAddressInfo"
                            class="detail-addr"
                            :style="useBroAddrStyle"
                            v-html="getAddressInfo"
                        ></div>
                    </div>
                    <div class="right-content">
                        <ul class="main-menu">
                            <menu-item
                                v-for="(menu, index) in z_menus"
                                :key="index"
                                :selfKey="'menu-' + index"
                                :expandKey="expandKey"
                                :menu="menu"
                                :smallDown="true"
                                :useMenuStyle="useMenuStyle"
                                :useSubMenuStyle="useSubMenuStyle"
                                @updateExpandKey="updateExpandKey"
                            />
                        </ul>
                    </div>
                </div>

                <div class="bottom-content">
                    <template v-if="footerAgentCustomContent">
                        <div
                            class="custom-content"
                            :style="{ color: fontColor }"
                            v-html="formatFontSize(footerAgentCustomContent)"
                        ></div>
                    </template>

                    <div
                        class="detail-info"
                        v-if="agentHasDisclaimer || subOwnerHasDisclaimer"
                    >
                        <template v-if="agentHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in footerAgentInfo.disclaimerList"
                                :key="index + 'mainfile'"
                                class="detail-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                        <!-- sub file -->
                        <template v-if="subOwnerHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in subOwnerInfo.disclaimerList"
                                :key="index + 'subfile'"
                                class="detail-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                    </div>
                    <closely-app-download useModule="md-footer" />
                    <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                        <a
                            href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                            target="_blank"
                            :title="$t('md-footer.realEstateConsumer')"
                            rel="noopener noreferrer"
                        >{{ $t('md-footer.realEstateConsumer') }}</a>
                    </div>

                    <div
                        v-if="noMlsDisclaimers.length > 0"
                        class="no-mls-disclaimer"
                    >
                        <div
                            class="claimer"
                            v-for="(noMls, index) in noMlsDisclaimers"
                            :key="index"
                            v-html="noMls.label"
                        ></div>
                    </div>

                    <div
                        v-if="socialNetworksInfo.length > 0"
                        class="share-links"
                    >
                        <a
                            v-for="(social, index) in socialNetworksInfo"
                            :key="social.id + '-' + index"
                            class="share-item"
                            :style="useCopyStyle"
                            :href="social.url"
                            :aria-label="social.socialNetwork"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont" :class="social.icon"></i>
                        </a>
                    </div>
                </div>
                <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
            </div>
            
            <div v-if="!hideCopyRight" class="copyright" :style="useCopyStyle">
                <div class="mg-container">
                    <p v-if="gfFlag != '1'" class="pt-content">
                        <span
                            class="made-in"
                            v-if="showCopyright"
                            v-html="
                                $t('md-footer.madeInAndCopyright', {
                                    chimeLink,
                                    year
                                })
                            "
                        ></span>
                        <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                    </p>
                    <p v-else class="pt-content">
                        {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                        <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '.././index.scss';

@mixin mobile() {
    .main-content .left-content {
        .site-logo {
            font-size: 30px;
            margin-bottom: 10px;

            .logo-item {
                margin: 0 20px 20px 0;
            }
        }

        .detail-info {
            p {
                word-break: break-word;
            }
        }

        .download-closely {
            .code-title {
                margin-bottom: 10px;
            }
        }
    }

    .bottom-content {
        padding-bottom: 20px;
    }
}

.md-footer.upgrade {
    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;

        &.inner {
            position: absolute;
        }
    }

    .footer-container {
        padding-top: 30px;
        @include color-theme('background-color');
    }

    .main-content {
        padding-bottom: 20px;
        display: flex;

        .left-content {
            max-width: 400px;

            .site-logo {
                font-size: 40px;
                margin-bottom: 30px;

                .logo-item {
                    margin-right: 30px;
                    height: 1em;
                }
            }

            .subdomain-detail {
                margin-top: 10px;
            }

            .detail-info {
                font-size: 14px;

                &.detail-info-file {
                    margin-top: 10px;
                }

                .detail-file {
                    color: #dedede;
                    opacity: 0.5;
                    cursor: pointer;
                }

                .detail-name {
                    font-family: var(--font-medium);
                    font-size: 20px;
                    line-height: 1.2;
                }

                .detail-phone-email {
                    font-size: 14px;
                    word-break: break-word;

                    .detail-phone {
                        margin-right: 20px;
                        line-height: 1.2;
                    }

                    .detail-email {
                        line-height: 1.2;
                    }

                    a:hover {
                        color: #fff;
                        color: var(--footer-hovercolor, #fff);
                    }
                }

                .detail-addr {
                    margin-top: 6px;
                    font-size: 14px;
                    line-height: 1.43;
                }
            }

            @include no-mls-disclaimer;

            .mls-declaimer {
                margin: 20px 0 20px 0;
                position: relative;

                .view-more {
                    font-size: 12px;
                    opacity: 0.6;
                }

                .view-more-content {
                    line-height: 1.5;
                    font-family: var(--font-normal);
                    white-space: normal;

                    p {
                        line-height: 1.5;
                    }
                }

                .more-btn {
                    display: inline-block;
                    font-family: var(--font-medium);
                    margin-top: 10px;
                }

                .single-mls {
                    margin-bottom: 20px;

                    .mls-logo {
                        height: 30px;
                        position: relative;
                        overflow: hidden;
                        margin-bottom: 10px;

                        img {
                            height: 30px;
                        }
                    }

                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
            }

            .share-links {
                margin-top: 21px;

                .share-item {
                    opacity: 0.5;

                    &:hover {
                        opacity: 1;
                    }

                    .iconfont {
                        font-size: 18px;
                    }

                    & + .share-item {
                        margin-left: 15px;
                    }
                }
            }

            .download-closely {
                margin: 25px 0;

                .code-wrapper {
                    .android {
                        margin-left: 30px;
                    }

                    justify-content: flex-start;
                }
            }
        }

        .right-content {
            flex: 1;
            padding-left: 30px;

            .main-menu {
                display: flex;
                flex-wrap: wrap;
                font-family: var(--font-bold);
                word-break: break-word;

                .menu-item {
                    width: 33.333%;
                    margin-bottom: 20px;

                    .footer-menu {
                        max-width: 100%;

                        span {
                            &:after {
                                content: '';
                                display: block;
                                width: 0;
                                height: 1px;
                                background-color: #fff;
                                transition: width 0.3s ease;
                            }
                        }

                        &:hover {
                            span {
                                &:after {
                                    width: 100%;
                                }
                            }
                        }

                        .icon-fashion-down {
                            font-size: 1.2em;
                            margin-left: 4px;
                        }
                    }

                    .footer-submenu {
                        margin-top: 5px;
                        font-family: var(--font-normal);
                        line-height: 1.2;

                        .sub-menu .submenu-text {
                            line-height: 1.43;
                        }

                        .sub-menu:hover a {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }

    .bottom-content {
        padding-bottom: 20px;
        
        .custom-content {
            padding-bottom: 30px;
        }

        .detail-info {
            font-size: 14px;

            .detail-file {
                color: #dedede;
                opacity: 0.5;
                cursor: pointer;
            }
        }

        @include no-mls-disclaimer;

        .no-mls-disclaimer .claimer {
            line-height: 1.5;
            margin-top: 12px;
        }

        .mls-declaimer {
            margin: 20px 0 20px 0;
            position: relative;

            .view-more {
                font-size: 12px;
                opacity: 0.6;
            }

            .view-more-content {
                line-height: 1.5;
                font-family: var(--font-normal);
                white-space: normal;

                p {
                    line-height: 1.5;
                }
            }

            .more-btn {
                display: inline-block;
                font-family: var(--font-medium);
                margin-top: 10px;
            }

            .single-mls {
                margin-bottom: 20px;

                .mls-logo {
                    height: 30px;
                    position: relative;
                    overflow: hidden;
                    margin-bottom: 10px;

                    img {
                        height: 30px;
                    }
                }

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }

        .download-closely {
            margin-bottom: 25px;

            .code-wrapper {
                .android {
                    margin-left: 30px;
                }

                .android,
                .ios {
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }

                justify-content: flex-start;
            }
        }

        .share-links {
            margin-top: 21px;

            .share-item {
                opacity: 0.5;

                &:hover {
                    opacity: 1;
                }

                .iconfont {
                    font-size: 18px;
                }

                & + .share-item {
                    margin-left: 15px;
                }
            }
        }
    }
    .md-footer_notshare{
        display:block;
        margin-bottom: 20px;
        color: #dedede;
    }

    .copyright {
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        p.pt-content {
            padding: 10px 0;
            color: #dedede;
            opacity: 0.5;
            a {
                white-space: nowrap;
            }
        }

        .bottom-declaimer-container {
            padding-top: 10px;

            .declaimer {
                font-size: 13px;
                line-height: 20px;
                color: #c8c8c8;
                padding-bottom: 15px;
            }
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    @include media-1080 {
        .main-content {
            .left-content {
                max-width: 100%;
            }

            .right-content {
                display: none;
            }
        }
    }

    @include media-800 {
        .copyright p.pt-content {
            text-align: left;
        }
    }

    @include media-600 {
        @include mobile();
    }

    &.inner {
        @include mobile();
        padding-top: 0;

        .mls-wrap {
            padding-top: 30px;
        }

        .main-content {
            .left-content {
                max-width: 100%;
            }

            .right-content {
                display: none;
            }
        }

        .mls-declaimer-container {
            padding: 10px var(--inner-padding, 20px);
        }

        .footer-container {
            padding: 50px var(--inner-padding, 20px);
        }
    }

    .mls-wrap {
        background-color: #f4f4f4;
        padding-bottom: 30px;
    }
}
</style>
